import React from 'react';
import classnames from 'classnames';

import DefaultHero from '../../Hero/DefaultHero';
// import AdditionalHero from '../../Hero/AdditionalHero';
import AsideInfo from '../../AsideInfo';
import AsideNav from '../../AsideNav';
import DefaultContent from '../../Content/DefaultContent';
// import Socials from 'components/partials/Socials';

import {
  gridContainer,
  asideInfoContainer,
  asideNavContainer,
  heroContainer,
  contentContainer,
} from './styles.module.scss';

const DefaultWrapper = ({ data, spyNavData, content }) => {
  const {
    title,
    uri,
    excerpt,
    featuredImage,
    GuideArticleText: { guideArticleTextAuthors },
    tags,
  } = data;

  return (
    <div className={classnames(gridContainer)}>
      <div className={classnames(heroContainer)}>
        <DefaultHero title={title} excerpt={excerpt} banner={featuredImage} />
      </div>

      <div className={classnames(asideInfoContainer)}>
        <AsideInfo
          authors={guideArticleTextAuthors}
          tags={tags}
          uri={uri}
          title={title}
          excerpt={excerpt}
        />
      </div>

      <div className={classnames(asideNavContainer, 'lg:mt-28 lg:pb-20')}>
        <div className="flex-1 h-full">
          <AsideNav data={spyNavData} />
        </div>
      </div>

      <div className={classnames(contentContainer, 'lg:mt-28')}>
        <DefaultContent content={content} />
      </div>
    </div>
  );
};

export default DefaultWrapper;
